import { useContext } from 'react';
import { Api } from 'vopay';
import { ApiContext } from './ApiContext';

export default function useApi(): Api {
  const api = useContext(ApiContext);

  if (!api) {
    throw new Error(
      "useApi: no ApiProvider mounted. Wrap the app in <ApiProvider api={api}> (from 'shared'), passing the host app's services/api.config instance.",
    );
  }

  return api;
}
